import React from "react";
import { YoutubeComponent } from "./youtube";
import { TwitchClipComponent } from "./twitch";

const Providers = {
  youtube: YoutubeComponent,
  twitch: TwitchClipComponent
};

export const Embed = props => {
  const ProviderEmbed = Providers[Object.keys(Providers).find(p => props.url.indexOf(p) > -1)];
  return ProviderEmbed && <ProviderEmbed {...props} />;
};



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/video.js